<template>
  <div class="detail-page" :class="{'blurbg':xid}">
    <div v-if="!xid" class="top-page-all">
      <div @click="onClickLeft" class="ret-btn"><</div>
      <div>我的客户列表</div>
    </div>
    <!--<div class="out-top" v-else>填写信息</div>-->
    <div v-if="!xid" class="top-bg-st"></div>
    <div v-if="!xid" class="content-box">
      <van-cell-group>
        <van-field v-model="info.realname" required clearable label="用户名" placeholder="请输入用户名"/>
        <van-field v-model="info.phone" type="phone" label="手机号" placeholder="请输入手机号" required/>

        <van-field
          v-if="!mid"
          v-model="info.password"
          type="password"
          label="密码"
          placeholder="请输入密码"
          required
        />

        <van-field
          @click="typeShow=true"
          v-model="typeLabel"
          label="类型"
          readonly="readonly"
          placeholder="请选择类型"
        />
        <van-popup :style="{width:'100%'}" position="bottom" v-model="typeShow">
          <van-picker :columns="selectList" @change="onChange"/>
        </van-popup>

        <van-field
          @click="ridShow=true"
          v-model="ridLabel"
          label="种类"
          readonly="readonly"
          placeholder="请选择种类"
        />
        <van-popup :style="{width:'100%'}" position="bottom" v-model="ridShow">
          <van-picker :columns="ridList" @change="onChangeRid"/>
        </van-popup>

        <van-field
          @click="show=true"
          v-model="info.province+info.city+info.county"
          type="phone"
          label="地区"
          readonly="readonly"
          placeholder="请选择地址"
        />
        <van-popup :style="{width:'100%'}" position="bottom" v-model="show">
          <van-area
            @confirm="addConfirm"
            @cancel="show=false"
            :style="{width:'100%'}"
            :area-list="areaList"
          />
        </van-popup>
        <van-field
          v-if="!xid"
          v-model="info.remarks"
          rows="3"
          autosize
          label="客户备注"
          type="textarea"
          placeholder="请输入备注可填写 用户类型、出生年月、或者职称"
        />
      </van-cell-group>

      <van-panel v-if="mid" title="授权书影币">
        <div slot="footer">
          <input
            placeholder="请输入书影币数量"
            style="width: 4.8rem;font-size: 14px"
            type="number"
            v-model="addMoney"
          />
          <div @click="giveMoney" class="btn-blur">授权书影币</div>
        </div>
      </van-panel>

      <div class="submit" @click="addData">提交</div>
    </div>
    <div v-else class="wb-content">
      <img class="wb-logo" src="//qn.xwyyjt.com/ht_xw_log_bg.png" alt="">
      <img class="wb-text" src="//qn.xwyyjt.com/ht_xw_wb_text.png" alt="">
      <div class="wb-form">
        <van-cell-group>
          <van-field v-model="info.realname" required clearable label="用户名" placeholder="请输入用户名"/>
          <van-field v-model="info.phone" type="phone" label="手机号" placeholder="请输入手机号" required/>
          <van-field
            v-if="!mid"
            v-model="info.password"
            type="password"
            label="密码"
            placeholder="请输入密码"
            required
          />

          <van-field
            @click="typeShow=true"
            v-model="typeLabel"
            label="类型"
            readonly="readonly"
            placeholder="请选择类型"
          />
          <van-popup :style="{width:'100%'}" position="bottom" v-model="typeShow">
            <van-picker :columns="selectList" @change="onChange"/>
          </van-popup>

          <van-field
            @click="ridShow=true"
            v-model="ridLabel"
            label="种类"
            readonly="readonly"
            placeholder="请选择种类"
          />
          <van-popup :style="{width:'100%'}" position="bottom" v-model="ridShow">
            <van-picker :columns="ridList" @change="onChangeRid"/>
          </van-popup>

          <van-field
            @click="show=true"
            v-model="info.province+info.city+info.county"
            type="phone"
            label="地区"
            readonly="readonly"
            placeholder="请选择地址"
          />
          <van-popup :style="{width:'100%'}" position="bottom" v-model="show">
            <van-area
              @confirm="addConfirm"
              @cancel="show=false"
              :style="{width:'100%'}"
              :area-list="areaList"
            />
          </van-popup>
          <van-field
            v-if="!xid"
            v-model="info.remarks"
            rows="3"
            autosize
            label="客户备注"
            type="textarea"
            placeholder="请输入备注可填写 用户类型、出生年月、或者职称"
          />
        </van-cell-group>
      </div>


      <div class="wb-submit" @click="addData">提交</div>
      <div class="has-zh"><span @click="goLogin">已有账号，去登陆</span></div>
    </div>

    <div class="jump-box" v-if="showSuccessCreate">
      <div class="jump-clr">
        恭喜你创建成功
        <br/>
        {{jumpTime}}秒后跳转到首页

        <div @click="removeJump" class="jump-remove">取消</div>
      </div>
    </div>

  </div>
</template>


<script>
  import province_list from "@/assets/js/dq.js";

  export default {
    name: "detail",
    data() {
      return {
        mid: "", //用户id
        addMoney: "",
        info: {
          realname: "",
          phone: "",
          rid: "",
          remarks: "",
          type: 0,
          province: "",
          city: "",
          county: "",
          password: ""
        },
        typeLabel: "普通用户",
        ridLabel: "",
        show: false,
        typeShow: false,
        ridShow: false,
        areaList: province_list,
        ridList: [],
        selectList: ["普通用户", "专业个人", "团队", "公司实体"],
        title: "用户",
        xid: "",
        postKey: true,
        jumpTime: 5,
        showSuccessCreate: false,
      };
    },
    mounted() {
      this.xid = this.$route.query.xid;
      this.mid = this.$route.query.mid;
      this.getRidList();
      this.title = this.mid ? "修改用户" : "新增用户";
      if (this.xid) {
        document.title = '书剧影音融媒体用户注册';
      }
    },
    methods: {
      goLogin() {
        window.location.replace('https://m.xwyyjt.com/login.html')
      },
      getRidList() {
        if (!this.mid) {
          this.changeType();
          return;
        }
        let token = window.localStorage.getItem("token");
        this.$http
          .post("customer", {
            token: token,
            mid: this.mid
          })
          .then(
            res => {
              if (res.data.code === 200) {
                let data = res.data.data;
                this.info.realname = data.realname;
                this.info.phone = data.phone;
                this.info.rid = data.rid;
                this.info.remarks = data.remarks;
                this.info.type = data.type;
                this.info.password = data.password;
                this.info.province = this.$route.query.province || "";
                this.info.city = this.$route.query.city || "";
                this.info.county = this.$route.query.county || "";
                this.onChange(
                  "",
                  this.selectList[this.info.type],
                  this.info.type
                );
                this.changeType(data.rid);
              } else {
                console.log(res)
                this.$toast(res.data.msg || "系统错误");
              }
            },
            e => {
              this.$toast("网络错误");
            }
          );
      },
      giveMoney() {
        let postUrl = "delegate";

        let token = window.localStorage.getItem("token");
        let obj = {
          token: token,
          delegatemoney: this.addMoney,
          mid: this.mid
        };

        this.$http.post(postUrl, obj).then(
          res => {
            if (res.data.code === 200) {
              this.delegatemoney = 0;
              this.$toast("授权书影币成功");
              setTimeout(() => {
                this.$router.go(-1);
              }, 1500);
            } else {
              this.$toast(res.data.msg || "系统错误");
            }
          },
          e => {
            this.$toast("网络错误");
          }
        );
      },
      addData() {
        if (this.postKey) {
          let postUrl = "";
          let obj = this.info;
          if (this.xid) {
            postUrl = "ownuseradd";
            obj.xid = this.xid;
            obj.remarks = "通过二维码注册";
          } else {
            postUrl = this.mid ? "userupdate" : "useradd";
            obj.token = window.localStorage.getItem("token");
            if (!obj.token) {
              this.$toast("未识别登录用户信息");
              return;
            }
            if (this.mid) {
              obj.mid = this.mid;
            }
          }
          if (!obj.realname) {
            this.$toast("请输入用户名");
            return;
          }
          if (!obj.phone) {
            this.$toast("请输入手机号");
            return;
          }
          if (!/^1[3456789]\d{9}$/.test(obj.phone)) {
            this.$toast("请输入正确的手机号");
            return;
          }

          if (!obj.password && postUrl != "userupdate") {
            this.$toast("请输入密码");
            return;
          }
          if (postUrl == "userupdate") {
            delete obj.password;
          }

          if (!obj.remarks) {
            this.$toast("请输入备注");
            return;
          }
          if (!obj.province) {
            this.$toast("请选择地区");
            return;
          }
          this.postKey = false;
          this.$http.post(postUrl, obj).then(
            res => {
              this.postKey = true;
              if (res && res.data && res.data.code === 200) {
                if (this.xid) {
                  this.goHomeTwo();
                  this.info = {
                    realname: "",
                    phone: "",
                    rid: "",
                    remarks: "",
                    type: 0,
                    province: "",
                    city: "",
                    county: ""
                  };
                } else {
                  this.$toast(res.data.msg || "添加成功");
                  setTimeout(() => {
                    this.$router.go(-1);
                  }, 1500);
                }
              } else {
                this.$toast(res.data.msg || "系统错误");
              }
            },
            e => {
              this.postKey = true;
              this.$toast("网络错误");
            }
          );
        }
      },
      goHomeTwo() {
        this.showSuccessCreate = true;
        window.jumpTime = setInterval(() => {
          this.jumpTime--;
          if (this.jumpTime === 0) {
            clearInterval(window.jumpTime)
            window.location.replace('https://m.xwyyjt.com/')
            this.jumpTime = 5;
            this.showSuccessCreate = false;
          }
        }, 1000);
      },
      removeJump() {
        clearInterval(window.jumpTime)
        this.jumpTime = 5;
        this.showSuccessCreate = false;
      },
      onClickLeft() {
        this.$router.go(-1);
      },
      addConfirm(picker) {
        this.info.province = picker[0].name;
        this.info.city = picker[1].name;
        this.info.county = picker[2].name;
        this.show = false;
      },
      onChangeRid(picker, value) {
        this.info.rid = value.rid;
        this.ridLabel = value.rname;
      },
      onChange(picker, value, index) {
        this.info.type = index;
        this.typeLabel = value;
        if (picker) {
          this.changeType();
        }
      },
      changeType(rid) {
        let type = this.info.type;
        this.ridLabel = "";
        this.ridList = [];
        this.$http
          .post("memberjb", {
            type: type
          })
          .then(
            res => {
              let list = res.data.data || [];
              let _list = list.map((item, index) => {
                return {...item, text: item.rname, value: item.rid};
              });
              this.ridList = _list;
              if (rid) {
                this.ridList.map((item, index) => {
                  item.rid == rid ? (this.ridLabel = item.rname) : "";
                });
                this.info.rid = rid;
              } else {
                this.ridLabel = this.ridList[0].rname;
                this.info.rid = this.ridList[0].rid;
              }
            },
            e => {
              this.$toast("网络错误");
            }
          );
      }
    }
  };
</script>

<style lang="scss">
  #app {
    background: #eeeeee;
  }

  .detail-page {
    height: 100%;

    &.blurbg {
      background: #057CFF;
    }

    .jump-box {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      background: rgba(0, 0, 0, 0.6);
      align-items: center;
      justify-content: center;

      .jump-clr {
        background: #ffffff;
        width: 3.8rem;
        height: 1.8rem;
        align-items: center;
        justify-content: center;
        display: flex;
        border-radius: 0.08rem;
        font-size: .32rem;
        text-align: center;
        color: #333;
        position: relative;
        padding-bottom: .88rem;
        line-height: 1.4;

        .jump-remove {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          border-top: 1px solid #f4f4f4;
          height: .88rem;
          text-align: center;
          color: #666666
        }
      }
    }

    .detail-page {
      .submit {
        margin-top: 1rem;
        height: 0.75rem;
        background: rgba(127, 207, 241, 1);
        font-size: 0.28rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }

    .out-top {
      text-align: center;
      line-height: 0.98rem;
    }

    .top-bg-st {
      position: relative;
      height: 2.4rem;
      width: 7.5rem;
      background-image: linear-gradient(to right, #038ED1, #1D208A);
    }

    .content-box {
      position: fixed;
      background: #ffffff;
      top: 1.24rem;
      width: 6.86rem;
      padding-bottom: 1.6rem;
      box-sizing: border-box;
      left: 0;
      right: 0;
      margin: 0 auto;
      border-radius: .32rem;
      padding-top: .32rem;
      color: #999999;
    }

    .wb-content {
      padding-bottom: .24rem;
      box-sizing: border-box;
      left: 0;
      right: 0;
      margin: 0 auto;
      padding-top: .32rem;
      color: #999999;
      background: #057CFF;

      .wb-logo {
        padding-top: .3rem 0 .55rem;
        margin: 0 auto;
        width: 3.4rem;
        height: auto;
        display: block;
      }

      .wb-text {
        display: block;
        margin: 0 auto;
        width: 4.8rem;
        height: auto;
        padding-bottom: .6rem;


      }

      .van-cell-group {
        background: #057CFF;
        color: #fff;

        .van-cell {
          background: #057CFF;
          color: #fff;

          input {
            background: #057CFF;
            color: #fff;

          }

        }
      }

      input::input-placeholder {
        color: #ffffff !important;
      }

      input::-webkit-input-placeholder {
        color: #ffffff !important;
      }

       
      input:-moz-placeholder {
        color: #ffffff !important;
      }

       
      input::-moz-placeholder {
        color: #ffffff !important;
      }

       
      input:-ms-input-placeholder {
        color: #ffffff !important;
      }

      .wb-submit {
        margin: .55rem auto .34rem;
        width: 5.5rem;
        height: .8rem;
        background-image: linear-gradient(to right, #FFC200, #FF5900);
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .4rem;
      }

      .has-zh {
        line-height: 1;
        font-size: .32rem;
        color: #ffffff;
        text-align: center;
        height: 2.8rem;
        background: url("https://qn.xwyyjt.com/ht_kh_yq_bg.png") no-repeat 0 0.2rem;
        background-size: 60%;
      }
    }

    .wb-form {
      padding: 0 1rem;
    }

    .van-cell, .van-cell__value, .van-field__control {
      color: #999999;
    }

    .btn-blur {
      border-radius: .12rem;
      margin-top: .12rem;
      padding: .12rem .32rem;
      border-right: .32rem;
      width: 1.6rem;
      background-image: linear-gradient(to right, #038ED1, #1D208A);
      color: #ffffff;
    }

    .submit {
      margin: .42rem auto 0;
      width: 4rem;
      height: .72rem;
      background-image: linear-gradient(to right, #038ED1, #1D208A);
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    [class*=van-hairline]::after {
      border: none;
    }
    .van-cell:last-child::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 0;
      bottom: 0;
      left: 16px;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(.5);
      transform: scaleY(.5);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/detail.vue